import type {
  FidsRingTypeOption,
  FidsTrackingRoute,
  FidsTrackingRoutePayload,
  FidsTrackingRouteSummary,
  FidsTrackingRouteWarehouseOption,
} from 'contracts/FidsTrackingRoutes';
import { api } from 'services';

const apiRoot = (api.defaults.baseURL || '').replace(/\/dashboard\/?$/, '');
const trackingRoutesPath = `${apiRoot}/api/v1/yms-portaria/fids/tracking-routes`;

// Rastreios: cada um é o centro de um radar ligado a vários armazéns.
export const listFidsTrackingRoutes = async (): Promise<
  FidsTrackingRouteSummary[]
> => {
  const { data } =
    await api.get<FidsTrackingRouteSummary[]>(trackingRoutesPath);
  return data;
};

export const getFidsTrackingRoute = async (
  id: number
): Promise<FidsTrackingRoute> => {
  const { data } = await api.get<FidsTrackingRoute>(
    `${trackingRoutesPath}/${id}`
  );
  return data;
};

// O rastreio novo nasce em rascunho.
export const createFidsTrackingRoute = async (
  payload: FidsTrackingRoutePayload
): Promise<FidsTrackingRoute> => {
  const { data } = await api.post<FidsTrackingRoute>(
    trackingRoutesPath,
    payload
  );
  return data;
};

export const updateFidsTrackingRoute = async (
  id: number,
  payload: FidsTrackingRoutePayload
): Promise<FidsTrackingRoute> => {
  const { data } = await api.put<FidsTrackingRoute>(
    `${trackingRoutesPath}/${id}`,
    payload
  );
  return data;
};

// Todos os armazéns, com o rastreio em que cada um já está.
export const listFidsTrackingRouteWarehouses = async (): Promise<
  FidsTrackingRouteWarehouseOption[]
> => {
  const { data } = await api.get<FidsTrackingRouteWarehouseOption[]>(
    `${trackingRoutesPath}/warehouses`
  );
  return data;
};

// Anéis de cada tipo de veículo, para desenhar no mapa.
export const listFidsRingTypes = async (): Promise<FidsRingTypeOption[]> => {
  const { data } = await api.get<FidsRingTypeOption[]>(
    `${trackingRoutesPath}/ring-types`
  );
  return data;
};

// Ativo: vale no painel. A API confere o centro e pelo menos 1 armazém.
export const activateFidsTrackingRoute = async (
  id: number
): Promise<FidsTrackingRoute> => {
  const { data } = await api.post<FidsTrackingRoute>(
    `${trackingRoutesPath}/${id}/activate`
  );
  return data;
};

export const deactivateFidsTrackingRoute = async (
  id: number
): Promise<FidsTrackingRoute> => {
  const { data } = await api.post<FidsTrackingRoute>(
    `${trackingRoutesPath}/${id}/deactivate`
  );
  return data;
};

// A cópia nasce em rascunho e sem armazéns.
export const duplicateFidsTrackingRoute = async (
  id: number
): Promise<FidsTrackingRoute> => {
  const { data } = await api.post<FidsTrackingRoute>(
    `${trackingRoutesPath}/${id}/duplicate`
  );
  return data;
};

export const deleteFidsTrackingRoute = async (id: number): Promise<void> => {
  await api.delete(`${trackingRoutesPath}/${id}`);
};
